import { render, staticRenderFns } from "./ItemDetailList - 副本.vue?vue&type=template&id=0ff4a068&scoped=true"
import script from "./ItemDetailList - 副本.vue?vue&type=script&lang=js"
export * from "./ItemDetailList - 副本.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailList - 副本.vue?vue&type=style&index=0&id=0ff4a068&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4a068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff4a068')) {
      api.createRecord('0ff4a068', component.options)
    } else {
      api.reload('0ff4a068', component.options)
    }
    module.hot.accept("./ItemDetailList - 副本.vue?vue&type=template&id=0ff4a068&scoped=true", function () {
      api.rerender('0ff4a068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/itemDetailPlugin/ItemDetailList - 副本.vue"
export default component.exports